import { taskBoardColumnKey } from "../constants";
import { isDueToday, isOverdue } from "./taskDates";

export function bucketForTask(task) {
    const col = taskBoardColumnKey(task);
    if (col === "Completed") return null;
    if (col === "Paused" || col === "Blocked") return "waiting";
    if (col === "In Progress" || isOverdue(task) || isDueToday(task) || !task.due_date) {
        return "now";
    }
    return "later";
}

export function nowQueueTasks(tasks = []) {
    return tasks.filter((task) => bucketForTask(task) === "now");
}

export function nextNowTask(tasks = [], exceptId) {
    return nowQueueTasks(tasks).find((task) => String(task.id) !== String(exceptId)) || null;
}
